/**
 * index
 */
'use strict';

let EventEmitter = require("events").EventEmitter;
const aas = window.AAS = new EventEmitter();

import Gnav from './_modules/common/Gnav';
import PageTransition from './_modules/common/PageTransition';
import homeKV from './_modules/home/homeKV';
import homeProjectsList from './_modules/home/homeProjectsList';
import homeMethods from './_modules/home/homeMethods';
//import homeNews from './_modules/home/homeNews';
import homeTicker from './_modules/home/homeTicker';
import projectsPickup from './_modules/projects/projectsPickup';
import recruitAd from './_modules/recruit/recruitAd';
import BtnScroll from './_modules/common/BtnScroll';
import FloatBanner from './_modules/common/FloatBanner';
//import Est2021Banner from './_modules/common/Est2021Banner';

let main = [];

/**
 * DOMContentLoaded
 */
document.addEventListener('DOMContentLoaded', () => {
  main['PageTransition'] = new PageTransition();
  main['homeProjectsList'] = new homeProjectsList();
  main['homeMethods'] = new homeMethods();
  //main['homeNews'] = new homeNews();
  main['homeTicker'] = new homeTicker();
  main['recruitAd'] = new recruitAd();
  main['BtnScroll'] = new BtnScroll();
  main['FloatBanner'] = new FloatBanner();
  //main['Est2021Banner'] = new Est2021Banner();

  new Gnav();
  new homeKV();
  new projectsPickup();

  if (!Modernizr.objectfit) objectFitImages();
}, false);

/**
 *
 */
if (Modernizr.effects) {
  // 1枚ずつスクロール
  console.log('scrollable 1');

  aas.on('load', () => {
    main['PageTransition'].start();
    main['FloatBanner'].start();
    //main['Est2021Banner'].start();
    main['homeTicker'].start();
    main['BtnScroll'].start();
  });
  aas.on('scrollable', () => {
    // フリースクロール開始
    console.log('scrollable 2');

    main['homeProjectsList'].start();
    main['homeMethods'].start();
    //main['homeNews'].start();

    main['homeTicker'].scrollable();

    main['recruitAd'].start();
    main['BtnScroll'].scrollable();

    //if (main['FloatBanner']) main['FloatBanner'].check();
    if (main['FloatBanner']) main['FloatBanner'].scrollable();
    //if (main['Est2021Banner']) main['Est2021Banner'].scrollable();
  });
} else {
  window.addEventListener('load', () => {

    // フリースクロール
    main['PageTransition'].start();
    main['homeProjectsList'].start();
    main['homeMethods'].start();
    //main['homeNews'].start();

    main['homeTicker'].start();
    main['homeTicker'].scrollable();

    main['recruitAd'].start();
    //main['BtnScroll'].check();
    main['BtnScroll'].start();
    main['BtnScroll'].scrollable();

    //new FloatBanner();
    main['FloatBanner'].start();
    main['FloatBanner'].scrollable();

    //est2021
    //main['Est2021Banner'].start();
    //main['Est2021Banner'].scrollable();
  }, false);
}

/**
 * window.unload（念のため）
 */
window.addEventListener('unload', () => {}, false);

